module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vgt-wrap__footer vgt-clearfix"
  }, [_c('div', {
    staticClass: "footer__row-count vgt-pull-left"
  }, [_c('span', {
    staticClass: "footer__row-count__label"
  }, [_vm._v(_vm._s(_vm.rowsPerPageText))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentPerPage),
      expression: "currentPerPage"
    }],
    staticClass: "footer__row-count__select",
    attrs: {
      "autocomplete": "off",
      "name": "perPageSelect"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.currentPerPage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.perPageChanged]
    }
  }, [_vm._l((_vm.rowsPerPageOptions), function(option, idx) {
    return _c('option', {
      key: 'rows-dropdown-option-' + idx,
      domProps: {
        "value": option
      }
    }, [_vm._v("\n        " + _vm._s(option) + "\n      ")])
  }), _vm._v(" "), (_vm.paginateDropdownAllowAll) ? _c('option', {
    domProps: {
      "value": _vm.total
    }
  }, [_vm._v(_vm._s(_vm.allText))]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "footer__navigation vgt-pull-right"
  }, [_c('a', {
    staticClass: "footer__navigation__page-btn",
    class: {
      disabled: !_vm.prevIsPossible
    },
    attrs: {
      "href": "javascript:undefined",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.previousPage($event)
      }
    }
  }, [_c('span', {
    staticClass: "chevron",
    class: {
      'left': !_vm.rtl, 'right': _vm.rtl
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.prevText))])]), _vm._v(" "), (_vm.mode === 'pages') ? _c('pagination-page-info', {
    attrs: {
      "totalRecords": _vm.total,
      "lastPage": _vm.pagesCount,
      "currentPage": _vm.currentPage,
      "ofText": _vm.ofText,
      "pageText": _vm.pageText
    },
    on: {
      "page-changed": _vm.changePage
    }
  }) : _c('div', {
    staticClass: "footer__navigation__info"
  }, [_vm._v(_vm._s(_vm.paginatedInfo))]), _vm._v(" "), _c('a', {
    staticClass: "footer__navigation__page-btn",
    class: {
      disabled: !_vm.nextIsPossible
    },
    attrs: {
      "href": "javascript:undefined",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.nextPage($event)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.nextText))]), _vm._v(" "), _c('span', {
    staticClass: "chevron",
    class: {
      'right': !_vm.rtl, 'left': _vm.rtl
    }
  })])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67ec64fa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-good-table/src/components/VgtPagination.vue
// module id = 1006
// module chunks = 1